/**
 * ScriptTab — the recruiter phone script (recruiter_script artifact).
 * Thin wrapper over TextArtifactPanel.
 */
import { StudyDetailResponse } from '../../types';
import TextArtifactPanel from './TextArtifactPanel';

export default function ScriptTab({ detail, isAdmin, onChanged }: { detail: StudyDetailResponse; isAdmin: boolean; onChanged: () => void }) {
  return (
    <TextArtifactPanel
      detail={detail}
      artifactType="recruiter_script"
      title="Recruiter phone script"
      emptyHint="No script yet. Upload the protocol in Documents, then generate a call script recruiters can read from."
      isAdmin={isAdmin}
      onChanged={onChanged}
    />
  );
}
